import React from 'react';

const OrderTableSkeleton = () => {
  // Generate 5 skeleton rows
  const skeletonRows = Array(10).fill(null);

  return (
    <div className="w-full overflow-x-auto bg-white rounded-lg shadow-sm">
      <table className="w-full">
        {/* Table Header */}
        <thead className="bg-gray-50 border-b border-gray-200 ">
          <tr>
            <th className="px-6 py-4 text-left text-medium font-semibold text-gray-500">
              Order Number
            </th>
            <th className="px-6 py-4 text-left text-medium font-semibold text-gray-500">
              Branch
            </th>
            <th className="px-6 py-4 text-left text-medium font-semibold text-gray-500">
              Phone
            </th>
            <th className="px-6 py-4 text-left text-medium font-semibold text-gray-500">
              Customer Name
            </th>
            <th className="px-6 py-4 text-left text-medium font-semibold text-gray-500">
              Amount
            </th>
            <th className="px-6 py-4 text-left text-medium font-semibold text-gray-500">
              Payment Mode
            </th>
            <th className="px-6 py-4 text-left text-medium font-semibold text-gray-500">
              Source
            </th>
            <th className="px-6 py-4 text-left text-medium font-semibold text-gray-500">
              Action
            </th>
          </tr>
        </thead>

        {/* Table Body - Skeleton Rows */}
        <tbody className="bg-white divide-y divide-gray-200">
          {skeletonRows.map((_, index) => (
            <tr key={index} className="hover:bg-gray-50">
              {/* Order Number */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
              </td>
              
              {/* Branch */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
              </td>
              
              {/* Phone */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-28"></div>
              </td>
              
              {/* Customer Name */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-32"></div>
              </td>
              
              {/* Order Date Time */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-36"></div>
              </td>
              
              {/* Delivery Date Time */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-36"></div>
              </td>
              
              {/* Amount */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
              </td>
              
              {/* Action */}
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex gap-2">
                  <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderTableSkeleton;